"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitProps = void 0;
/**
 * Get object without particular keys
 */
const omitProps = (object, propNames) => {
    return Object.keys(object).reduce((acc, key) => {
        if (propNames.includes(key))
            return acc;
        acc[key] = object[key];
        return acc;
    }, {});
};
exports.omitProps = omitProps;
//# sourceMappingURL=omitProps.js.map